import { render, staticRenderFns } from "./main-sidebar-sub-menu.vue?vue&type=template&id=98ab2fb8"
import script from "./main-sidebar-sub-menu.vue?vue&type=script&lang=js"
export * from "./main-sidebar-sub-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports